export const iconFontAwesomeEnergyCircleRadiation = (
	<i className="fa-solid fa-circle-radiation"></i>
);
